import { createGlobalStyle } from 'styled-components';
import { rem } from 'polished';

const lightGray = '#D4D6D7';
const gray = '#63676A';
const blue = '#0071b8';
const darkBlue = '#005AB4';
const red = '#C8302B';
const green = '#66883E';

const size = {
  xs: '320px',
  sm: '768px',
  lg: '1200px',
};

export const device = {
  xs: `min-width: ${size.xs}`,
  sm: `min-width: ${size.sm}`,
  lg: `min-width: ${size.lg}`,
};

const spacing = {
  sm: '5px',
  md: '10px',
  lg: '25px',
  xl: '50px',
};

const fontSize = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '36px',
  xl: '52px',
};

export const GlobalStyle = createGlobalStyle`
  html, body {
    box-sizing: border-box;
    font-family: "Gotham-Book";
  };

  * {
    box-sizing: inherit;
  };

  body {
    margin: 0;
    color: white;
    line-height: 1.4;
    background-color: black;
    padding-bottom: ${spacing.xl};
    font-size: ${rem(fontSize.md)};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  };

  h1 {
    font-size: ${rem(fontSize.lg)};
    line-height: 1;
  };

  a,
  a:visited {
    color: ${darkBlue};
    text-decoration: none;
  };

  .info {
    font-size: ${rem(fontSize.sm)};
  };

  input[type="text"],
  input[type="email"],
  input[type="phone"],
  input[type="password"],
  select {
    width: 100%;
    color: white;
    border: none;
    display: block;
    background-color: black;
    border-bottom: 1px solid ${gray};
    padding: ${spacing.md};
    border-width: 1px 1px 2px;
    border-style: solid;
    border-color: white;
    font-size: ${rem(fontSize.md)};
  };

  input:hover,
  input:focus-within,
  input:active {
    border-radius: 0;
    outline: 0;
  };

  input:focus-within {
    border-bottom-color: ${blue};
  };

  .react-dropdown-select {
    border-radius: 0 !important;
    border-bottom: 1px solid ${gray} !important;
    padding: ${spacing.md} !important;
    border-width: 1px 1px 2px !important;
    border-style: solid !important;
    border-color: #97979726 #97979726 #cfcfcf !important;
    width: 100% !important;
    font-size: ${rem(fontSize.md)} !important;
  };

  .react-dropdown-select-dropdown {
    background: black !important;
  }

  .react-dropdown-select:focus,
  .react-dropdown-select:focus-within {
    box-shadow: none !important;
    border-bottom-color: ${blue} !important;
  };

  .react-dropdown-select ins {
    display: none !important;
  };

  .react-dropdown-select input {
    font-size: ${rem(fontSize.md)} !important;
  };

  .react-dropdown-select-item-selected {
    background-color: ${blue} !important;
  };

  .react-dropdown-select-option-remove:hover {
    color: white !important;
  };

  .react-dropdown-select-option {
    background-color: ${blue} !important;
  };

  .react-dropdown-select-item {
    border-bottom: none !important;
  }

  .react-dropdown-select-item:hover {
    background-color: ${lightGray} !important;
    color: black !important;
  };

  select {
    background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+);
    background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIiAgcHJlc2VydmVBc3BlY3RSYXRpbz0ieE1heFlNaWQiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO30uY2xzLTJ7ZmlsbDojNDQ0O308L3N0eWxlPjwvZGVmcz48dGl0bGU+YXJyb3dzPC90aXRsZT48cmVjdCBjbGFzcz0iY2xzLTEiIHdpZHRoPSI0Ljk1IiBoZWlnaHQ9IjEwIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjEuNDEgNC42NyAyLjQ4IDMuMTggMy41NCA0LjY3IDEuNDEgNC42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIzLjU0IDUuMzMgMi40OCA2LjgyIDEuNDEgNS4zMyAzLjU0IDUuMzMiLz48L3N2Zz4=);
    background-repeat: no-repeat;
    background-position: 98% 50%;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
  };

  select::-ms-expand {
    display: none;
  };

  .css-wmw4vi-ReactDropdownSelect.error {
    border-bottom-color: ${red} !important;
  };

  .css-wmw4vi-ReactDropdownSelect.valid {
    border-bottom-color: ${green} !important;
  };

  input.error, select.error {
    border-bottom-color: ${red};
  };

  input.valid, select.valid {
    border-bottom-color: ${green};
  }

  .fsp-picker {
    justify-content: flex-end !important;
  }

  .fsp-modal {
    margin-bottom: 100px;
  }

  .full-page-content {
      width: 100%;
      padding: var(--space-md);
      margin: var(--header-height) auto 0 auto;
      height: calc(100% - var(--header-height)); 
      max-height: calc(1080px - var(--header-height));
    }
    
    .full {
      max-height: 100%;
    }
    
    .form {
      max-width: 720px;
      max-height: 100%;
    }

    span.red {
      color: var(--c-red);
    }
`;
